import React from "react";
import { BsTwitterX } from "react-icons/bs";
import { FaFacebook, FaInstagram, FaLinkedinIn } from "react-icons/fa";
import UserAvatar from "../../components/UserAvatar";
import { formatDate } from "../../utils/Date";

const UserProfile = ({ selectedTicket }) => {
  if (!selectedTicket) {
    return (
      <div className="w-1/4 border-gray-200 p-6 bg-[#FEFEFE] overflow-y-auto">
        <p className="text-base font-semibold text-gray-500">
          Select a ticket to view user details
        </p>
      </div>
    );
  }

  return (
    <div className="bg-[#F4F5F6] border-gray-200 h-full p-6  overflow-y-auto">
      <div className="text-center">
        <div className="mb-4 border-b border-gray-200">
          <h2 className="my-4 text-base font-semibold text-start">
            {selectedTicket?.userId?.firstName +
              " " +
              selectedTicket?.userId?.lastName}
          </h2>
        </div>
        <div className="flex items-center justify-center h-48">
          <UserAvatar
            user={selectedTicket?.userId}
            variant="default"
            size="w-24 h-24"
          />
        </div>
      </div>
      <div className="space-y-4 text-sm font-medium">
        <div>
          <h3 className=" text-gray-500">EMAIL</h3>
          <p>{selectedTicket?.userId?.email}</p>
        </div>
        <div>
          <h3 className=" text-gray-500">PHONE</h3>
          <p>{selectedTicket?.userId?.phone}</p>
        </div>
        <div>
          <h3 className=" text-gray-500">LOCATION</h3>
          <p>{selectedTicket?.userId?.homeAddress}</p>
        </div>

        <div>
          <h3 className=" text-black mb-1">About User</h3>
          <p className=" text-gray-600">{selectedTicket?.userId?.title}</p>
        </div>
        <div>
          <div className="space-y-2">
            {[
              {
                label: "Full Name:",
                value:
                  selectedTicket?.userId?.firstName +
                  " " +
                  selectedTicket?.userId?.lastName,
              },
              { label: "Phone number:", value: selectedTicket?.userId?.phone },
              {
                label: "Date of Birth:",
                value: formatDate(selectedTicket?.userId?.dateOfBirth),
              },
              { label: "Language:", value: "English" },
              { label: "Country:", value: selectedTicket?.userId?.country },
            ].map(({ label, value }) => (
              <div className="flex" key={label}>
                <span className="text-gray-500 w-32">{label}</span>
                <span className="flex-1">{value}</span>
              </div>
            ))}
          </div>

          <h3 className="mt-10 mb-3 text-sm font-semibold text-gray-500">
            Connect with me
          </h3>
          <div className="flex space-x-4">
            {selectedTicket?.userId?.socialLink?.map((social) => {
              let Icon;
              switch (social.name.toLowerCase()) {
                case "facebook":
                  Icon = FaFacebook;
                  break;
                case "linkedin":
                  Icon = FaLinkedinIn;
                  break;
                case "twitter":
                  Icon = BsTwitterX;
                  break;
                case "instagram":
                  Icon = FaInstagram;
                  break;
                default:
                  return null;
              }

              return (
                <a
                  key={social.id}
                  href={
                    social.url.startsWith("http")
                      ? social.url
                      : `https://${social.url}`
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-700 hover:text-gray-900"
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
